import { useContext } from 'react';

import { useQuery } from '@apollo/client';
import { useDisclosure } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { BootReason, Deal, dealQuery } from '../../gql/dealGql';
import { useDealUpdateRequestBootMutation } from '../../gql/generated/graphql';
import { Note } from '../../gql/noteGql';

import BootDealModal from '../../components/BootDealModal';
import DealStateHistory from '../../components/DealStateHistory';
import Footer from './components/Footer';
import Header from './components/Header';

import { useUser } from '../../hooks/useUser';
import { DealProvider } from '../../libs/DealContext';
import { FiltersContext } from '../../libs/contextLib';
import { getTimezoneStr } from '../../libs/utils';

const TitlingDealDetail = () => {
  const {
    filters: {
      global: { sources, types },
    },
  } = useContext(FiltersContext);
  const user = useUser();
  const { id } = useParams<{ id: string }>();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isBootModalOpen,
    onClose: onCloseBootModal,
    onOpen: onBootModalOpen,
  } = useDisclosure();

  const [requestBoot] = useDealUpdateRequestBootMutation();

  const { data, loading } = useQuery(dealQuery, {
    variables: {
      id,
      sources,
      types,
    },
    fetchPolicy: 'network-only',
  });

  const deal = data?.deal ?? new Deal();

  const onBootConfirm = async (bootReason: BootReason) => {
    try {
      const partial_note = {
        deal_id: deal.id,
        author_id: user.id,
        creation_date_tz: getTimezoneStr(),
      } as Note;

      await requestBoot({
        variables: {
          partial_note,
          id: deal.id,
          request_boot: true,
          boot_reason: bootReason,
          boot_deal: false,
        },
      });
      toast.success('Deal Removed');
      onCloseBootModal();
    } catch (e) {
      toast.error('Failed to remove deal.');
    }
  };

  return (
    <DealProvider>
      <Header loading={loading} onOpen={onOpen} />
      <Footer loading={loading} setShowBootModal={onBootModalOpen} />
      <DealStateHistory isOpen={isOpen} onClose={onClose} />
      <BootDealModal
        isOpen={isBootModalOpen}
        onClose={onCloseBootModal}
        onBootConfirm={onBootConfirm}
      />
    </DealProvider>
  );
};

export default TitlingDealDetail;
